// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"32b79584","553":"080af7f5","977":"d05da838"}[chunkId] + ".chunk.js";
};